import { TsDOM as q } from '@/scripts/core/TsDOM'
import { UcoastEl } from '@/scripts/core/UcoastEl'
import { ProductVariant } from '@/scripts/shopify'
import { type EmblaSlider } from '../theme/embla-slider'

export class BuildSetDrawer extends UcoastEl {
    static htmlSelector = 'build-set-drawer'
    static selectors = {
        overlay: '[data-uc-build-set-drawer-overlay]',
        toggle__link: '.build-set__toggle',
        container: '#BuildSetDrawer',
        inner: '[data-uc-build-set-drawer-inner]',
        atcButton: '.build-set-add',
        previewItem: '.preview-item',
        previewToggle: '.build-item__toggle',
        emblaButtons: '.embla__button'
    }
    activeElement?: HTMLElement
    atcButton: HTMLButtonElement
    previewToggles?: NodeListOf<HTMLButtonElement>
    previewItem?: HTMLElement
    emblaButtons?: NodeListOf<HTMLButtonElement>

    constructor() {
        super()
        this.atcButton = q.rs(BuildSetDrawer.selectors.atcButton, this)
        this.previewToggles = q.ol(BuildSetDrawer.selectors.previewToggle, this)

        this.emblaButtons = q.ol(BuildSetDrawer.selectors.emblaButtons, this)

        this.previewToggles?.forEach(toggle => {
            toggle.addEventListener('click', this.toggleItem.bind(this))
        })

        this.emblaButtons?.forEach(button => {
            button.addEventListener('click', this.onChangeVariant.bind(this))
        })

        this.querySelectorAll('.swatch-link')?.forEach(swatch => {
            swatch.addEventListener('click', this.onSwatchEvent.bind(this))
        })

        this.querySelectorAll('[data-product-form-input] label').forEach(label => {
            label.addEventListener('click', this.onClickLabel.bind(this))
        })
    }

    override connectedCallback(): void {
        this.addEventListener(
            'keyup',
            (evt) => evt.code === 'Escape' && this.close()
        )
        this.getOverlay().addEventListener('click', this.close.bind(this))
        this.setDrawerLinkAccessibility()
    }

    getOverlay() {
        return q.rs(BuildSetDrawer.selectors.overlay, this)
    }

    setDrawerLinkAccessibility() {
        const toggle__links = q.ol(BuildSetDrawer.selectors.toggle__link)
        toggle__links?.forEach(toggle__link => {
            toggle__link.setAttribute('role', 'button')
            toggle__link.setAttribute('aria-haspopup', 'dialog')
            toggle__link.addEventListener('click', (event) => {
                event.preventDefault()
                this.open(toggle__link)
            })
            toggle__link.addEventListener('keydown', (event) => {
                if (event.code?.toUpperCase() === 'SPACE') {
                    event.preventDefault()
                    this.open(toggle__link)
                }
            })
        })
    }

    open(triggeredBy?: HTMLElement) {
        if (triggeredBy) this.setActiveElement(triggeredBy)
        setTimeout(() => {
            this.classList.add('animate', 'active')
        }, 1)
        this.addEventListener(
            'transitionend',
            () => {
                const containerToTrapFocusOn = q.rs(BuildSetDrawer.selectors.container, this)
                const focusElement = q.os(BuildSetDrawer.selectors.inner, this)
                window.TsDOM.trapFocus(containerToTrapFocusOn, focusElement)
                void window.Ucoast.mediaManager.playAllInContainer(this)
            },
            { once: true }
        )
        document.body.classList.add('overflow-hidden')
    }

    close() {
        this.classList.remove('active')
        window.TsDOM.removeTrapFocus(this.activeElement)
        document.body.classList.remove('overflow-hidden')
    }

    setActiveElement(element: Element | null) {
        if (!element) throw new Error('Active element is required')
        this.activeElement = element as HTMLElement
    }

    onChangeVariant(event: Event | null) {
        let available = true
        let price = 0

        setTimeout(() => {
            if(event) {
                const setBuildItem = q.rt<Event, HTMLElement>(event).closest('.build-set-item') as HTMLElement
                
                if(setBuildItem) {
                    const emblaSlider = q.rs<EmblaSlider>('embla-slider', setBuildItem)
                    const selectedIndex = emblaSlider?.getSelectedIndex() || 0
                    const productInfoList = q.rl('.product-info-wrapper', setBuildItem)
                    productInfoList.forEach((item, index) => {
                        if(index == selectedIndex) item.classList.remove('hidden')
                        else item.classList.add('hidden')
                    })
                }
            }
    
            q.rl('.main-product .product-info-wrapper:not(.hidden) product-info:not(.hidden), .build-set-item:not(.hidden) .product-info-wrapper:not(.hidden) product-info:not(.hidden)', this).forEach((item, index) => {
                try {
                    const jsonElement = q.rs('variant-radios [type="application/json"]', item)
                    const idInput = q.rs<HTMLInputElement>('product-form [name="id"]', item)
                    
                    if (!jsonElement?.textContent || !idInput?.value) {
                        console.warn(`Missing data in item ${index}`)
                        return
                    }
    
                    const varianats = JSON.parse(jsonElement.textContent) as ProductVariant[]
                    const variantID = Number(idInput.value)
                    
                    if (isNaN(variantID)) {
                        console.warn(`Invalid variant ID in item ${index}`)
                        return
                    }
    
                    const currentVariant = varianats.find(v => 
                        v.id === variantID
                    )
    
                    if (!currentVariant) {
                        console.warn(`Variant ${variantID} not found in item ${index}`)
                        return
                    }
    
                    if(index == 2 && !this.querySelector('[name="items[2][id]"]')) {
                        const inputWrapper = q.rs('.build-set-form-inputs')
                        const inputElements = `
                            <input name="items[2][id]" data-uc-product-variant-id type="hidden" value="${variantID}">
                            <input name="items[2][Color]" data-uc-product-variant-id type="hidden" value="${currentVariant.option1 || ''}">
                            <input name="items[2][Size]" data-uc-product-variant-id type="hidden" value="${currentVariant.option2 || ''}">
                        `
                        inputWrapper.innerHTML = inputWrapper.innerHTML + inputElements
                    }
    
                    const updateInput = (name: string, value: string) => {
                        const input = q.rs<HTMLInputElement>(`[name="items[${index}][${name}]"]`);
                        input?.value !== undefined && (input.value = value);
                    }
    
                    updateInput('id', idInput.value)
                    updateInput('Color', currentVariant.option1 || '')
                    updateInput('Size', currentVariant.option2 || '')
    
                    available = available && currentVariant.available
                    price = price + currentVariant.price
    
                } catch (e) {
                    console.error(`Error processing item ${index}:`, e)
                    available = false
                }
            });
    
            if(!this.atcButton) return
            const preText = this.atcButton.dataset.text || ''
            const textElement = q.rs('[data-uc-inventory-status-text]',this.atcButton)
    
            this.atcButton.toggleAttribute('disabled', !available)
            this.atcButton.setAttribute('aria-disabled', String(!available))
            if(textElement) {
                textElement.textContent = preText + this.moneyFormat(Number(price))
            } 
        }, 200);
    }

    toggleItem(event: Event) {
        event.preventDefault()
        this.previewItem = q.rs(BuildSetDrawer.selectors.previewItem, this)
        if(!this.previewItem || !this.previewToggles) return
        this.previewItem.classList.add('hidden')
        this.previewItem.previousElementSibling?.classList.remove('hidden')
        this.previewToggles.forEach(toggle => {
            toggle.classList.add('hidden')
        })
        const previewEmblaSlider = q.rs<EmblaSlider>('embla-slider', this.previewItem)
        const selectedIndex = previewEmblaSlider?.getSelectedIndex() || 0
        const setBuildItem = this.previewItem.previousElementSibling as HTMLElement
        const setSlider = q.rs<EmblaSlider>('embla-slider', setBuildItem)
        setSlider?.scrollMove(selectedIndex)
        const productInfoList = q.rl('.product-info-wrapper', setBuildItem)
        productInfoList.forEach((item, index) => {
            if(index == selectedIndex) item.classList.remove('hidden')
            else item.classList.add('hidden')
        })

        this.onChangeVariant(null)
    }

    moneyFormat(money: number) {
        return `${this.dataset.currency}${(money / 100).toFixed(2)}`;
    }

    onSwatchEvent(event: Event) {
        event.preventDefault()
        const swatch = q.rClosestTarget(event, '.swatch-link')
        const productId = swatch.dataset.productId
        const buildSetItem = q.rc(swatch, '.build-set-item')
        if(buildSetItem.querySelector('.embla__slide')) {
            buildSetItem.querySelectorAll('.embla__slide.is-snapped .card__media').forEach(item => {
                if(item.dataset.productId == productId) item.classList.remove('hidden')
                else item.classList.add('hidden')
            })
        } else {
            buildSetItem.querySelectorAll('.card__media').forEach(item => {
                if(item.dataset.productId == productId) item.classList.remove('hidden')
                else item.classList.add('hidden')
            })
        }

        buildSetItem.querySelectorAll('.product-info-wrapper:not(.hidden) product-info').forEach(item => {
            if(item.dataset.productId == productId) item.classList.remove('hidden')
            else item.classList.add('hidden')
        })

        this.onChangeVariant(null)
    }

    onClickLabel() {
        setTimeout(() => {
            this.onChangeVariant(null)
        }, 100);
    }
}